<template>
	<section class="section" v-if="isVisible">
		<article class="message is-danger">
			<div class="message-header">
				<p>General Disclaimer</p>
				<button class="delete" aria-label="delete" @click="toggleVisibility"></button>
			</div>
			<div class="message-body">
				<strong>We strongly recommend</strong> that you consult with your physician before beginning any exercise program. You should be in good physical condition and be able to participate in the exercise.
				</br>
				You should understand that when participating in any exercise or exercise program, there is the possibility of physical injury. If you engage in this exercise or exercise program, you agree that you do so at your own risk, are voluntarily participating in these activities, and assume all risk of injury to yourself.
				</br>
				If you are a coach using this tool, remember that you are responsible for your athletes health, and should always program to prevent and avoid injury. </br></br>
				<button class="button is-danger is-outlined is-right" @click="toggleVisibility">
					Got it, go away
				</button>
			</div>

		</article>
	</section>
</template>

<script>

export default {
	name: 'disclaimer',

	data() {
		return {
			isVisible: false
		}
	},

	methods: {
		toggleVisibility: function() {
			this.isVisible = false
		}
	}
}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Disclaimer.vue